import { portalApi, usePortalAuth } from "@/lib/portalAuth";
import { ChangePasswordForm } from "@/components/common/ChangePasswordForm";
import { PORTAL } from "@/constants/testIds";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Cuenta() {
  usePageTitle("Mi cuenta");
  const { usuario } = usePortalAuth();

  return (
    <div className="mx-auto max-w-5xl px-5 py-8">
      <h1 className="text-xl font-semibold text-[var(--tc-text)]">Mi cuenta</h1>
      <p className="mt-1 text-sm text-[var(--tc-text-secondary)]">{usuario?.nombre} · {usuario?.email}</p>

      <div className="mt-6 rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-6">
        <h2 className="text-base font-semibold text-[var(--tc-text)]">Cambiar contraseña</h2>
        <p className="mt-1 mb-4 text-sm text-[var(--tc-text-secondary)]">
          Cerramos las demás sesiones activas de tu cuenta al guardar.
        </p>
        <ChangePasswordForm
          api={portalApi}
          tokenStorageKey="tc_portal_token"
          testIds={{
            currentInput: PORTAL.cuentaCurrentPasswordInput,
            newInput: PORTAL.cuentaNewPasswordInput,
            confirmInput: PORTAL.cuentaConfirmPasswordInput,
            submitButton: PORTAL.cuentaSubmitButton,
            error: PORTAL.cuentaError,
            success: PORTAL.cuentaSuccess,
          }}
        />
      </div>
    </div>
  );
}
